import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EnvironmentType } from '@fleet-beat/core';

@Component({
  selector: 'fb-environment-check',
  templateUrl: './environment-check.component.html',
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentCheckComponent {
  @Input() environments: EnvironmentType[];
  @Input() devQa: boolean = false;
  @Input() stageProdDemo: boolean = false;
}
